<template>
  <div class="mb-4">
    <form>
      <div class="form-group row p-3">
        <div class="col-12 p-0 text-right">
          <p class="btn rounded shadow-sm" @click="hide_time = true">
            {{ $t("Pickup Time") }} :
            <img src="@/assets/media/icons/duotone/Contacts/Clock.svg" />
            {{ time_selected }} <span v-if="time_selected == 'ASAP' && restaurant.cooking_time">
              ({{
                restaurant.cooking_time
               }})</span> 
          </p>
        </div>
      </div>

      <div
        class="row time-wrap shadow-sm"
        v-if="hide_time"
        v-click-outside="hide"
        style="
          background: white;
          position: absolute;
          z-index: 4;
          width: 98%;
          height: 200px;
          padding: 1rem !important;
          margin-top: -15px;
          margin-right: 5px;
          border: 1px solid #f5f8fa;
          border-radius: 5px;
        "
      >
        <div class="col-4 p-0">
          <p class="btn btn-block shadow-sm" @click="settime('ASAP')">
            {{ $t("ASAP") }}
          </p>
          <p class="btn btn-block">{{ $t("Time") }}</p>
        </div>
        <div class="col-8">
          <div
            style="
              overflow-y: auto;
              height: 185px;
              margin-left: -10px;
              margin-right: -30px;
              margin-top: -15px;
            "
          >
            <p
              class="btn ml-2"
              style="width: 90%"
              :class="{ selected_time: time_selected == time }"
              @click="settime(time)"
              v-for="time of times"
              :key="time"
            >
              {{ time }}
            </p>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import moment from 'moment'
import store from "@/store";
import VueTimepicker from "vue-time-picker";
export default {
  name: "PickupTime",
  components: { VueTimepicker },
  data: () => ({
    time_selected: "ASAP",
    hide_time: false,
  }),
  methods: {
    hide() {
      this.hide_time = false;
    },
    settime(time) {
      this.time_selected = time;
      this.hide_time = false; 
      if(time == 'ASAP') 
        this.$emit("input", moment().format('YYYY-MM-DD hh:mm A'))
      else
        this.$emit("input",  moment().format('YYYY-MM-DD') + ' ' + time );
    },
    convert_string_time(time) {
      return time.slice(-2);
    },
    calcTime(opentime) {
      let start_hh = new Date().getHours(),
        end_hh = 24;
      let start_mm = 0,
        end_mm = 0;
      if (!opentime.is_24h) {
        start_hh = opentime.start_time.split(":")[0];
        end_hh = opentime.end_time.split(":")[0];
        start_mm = opentime.start_time.split(":")[1];
        end_mm = opentime.start_time.split(":")[1];
      }
      var ap = ["AM", "PM"]; // AM-PM
      var times = [];
      let current_time = new Date().getHours() * 60 + new Date().getMinutes();
      let start_time = start_hh * 60 + Number(start_mm);
      let end_time = end_hh * 60 + Number(start_mm);

      for (var hour = start_hh; hour < end_hh; hour++) {
        for (var mm = 0; mm < 60; mm += 15) {
          var loop_time = hour * 60 + mm;
          if (
            start_time <= loop_time &&
            end_time >= loop_time &&
            current_time < loop_time
          ) {
            if (("0" + (hour % 12)).slice(-2) == "00") var hh_ = "12";
            else hh_ = ("0" + (hour % 12)).slice(-2);
            if (mm == 0) var mm_ = "00";
            if (mm != 0) mm_ = mm;
            times.push(`${hh_}:${mm_} ` + ap[Math.floor(hour / 12)]);
          }
        }
      } 
      return times;
    },
  },
  mounted() {},
  computed: {
    restaurant() {
      return store.getters["location_selected/placeSelected"];
    },
    times() {
      let opentimes = this.restaurant.open_times || [];
      let times = [];
      opentimes.forEach((m) => {
        this.calcTime(m).forEach((v) => {
          var added = times.includes(v);
          if (!added) times.push(v);
        });
      });
      return times;
    },
  },
};
</script>
<style lang="css">
.selected_time {
  border: 1.5px dotted #700E57 !important;
}
.time-wrap {
  display: block;
  -webkit-animation: fadeIn 0.2s;
  animation: fadeIn 0.2s;
}
@-webkit-keyframes fadeIn {
  from {
    opacity: 0.5;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0.5;
  }
  to {
    opacity: 1;
  }
}
</style>